/* J&S weekly gift pilot. Native Shopify BXGY is the only authority for the free price,
 * date range, usage cap and qualifying products. Keeps the existing Kaching/DingDoong checkout.
 */
(() => {
  'use strict';
  const element = document.getElementById('js-week-goodie-config');
  if (!element || window.jaesaWeekGoodie) return;
  window.jaesaWeekGoodie = true;
  const config = JSON.parse(element.textContent);
  const baseFetch = window.fetch.bind(window);
  const owned = item => item.variant_id === config.giftVariantId && item.properties?._js_week_goodie === 'bbq-v1';
  const codes = new Set(config.windows.map(x => x.code.toUpperCase()));
  const food = new Set(config.eligibleProductIds);
  const checkoutSelector = '.kaching-cart__checkout-button,button[name="checkout"],input[name="checkout"],a[href^="/checkout"],a[href*="/checkouts/"]';
  const bypass = new WeakSet();
  let timer, running = null, lastCart = null, status = '', failed = false, rejected = '';
  let declined = false;
  try { declined = sessionStorage.getItem('js-week-goodie-declined') === '1'; } catch (_) {}
  function windowNow() {
    const now = Date.now();
    return config.enabled && config.windows.find(x => now >= Date.parse(x.startsAt) && now < Date.parse(x.endsAt));
  }
  async function json(route, body) {
    const response = await baseFetch(route, body === undefined ? {cache:'no-store',headers:{Accept:'application/json'}} : {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    if (!response.ok) throw new Error('Cart update failed');
    return response.json();
  }
  function eligibility(cart, win) {
    if (!win || declined || cart.currency !== 'EUR') return false;
    if (cart.items.some(x => x.selling_plan_allocation || config.excludeHandles.includes(x.handle))) return false;
    if (cart.discount_codes?.some(x => !codes.has(x.code.toUpperCase()))) return false;
    if (cart.items.some(x => !owned(x) && x.final_line_price === 0 && x.quantity > 0 && ![47644005335387,47643994227035].includes(x.variant_id))) return false;
    // The existing Flanksteak and Rinderlende gifts can coexist with the BBQ gift.
    const amount = cart.items.filter(x => !owned(x) && food.has(x.product_id)).reduce((n,x)=>n+x.final_line_price,0);
    return amount >= config.minimumCents;
  }
  function free(cart) {
    const gifts = cart.items.filter(owned);
    return gifts.length === 1 && gifts[0].quantity === 1 && gifts[0].final_line_price === 0 &&
      gifts[0].discounts?.some(x => codes.has((x.title || '').toUpperCase()) || /Wochenplanung: BIO BBQ Sauce dazu|J&S BBQ QA/.test(x.title || ''));
  }
  async function removeOwned(cart) {
    const gifts = cart.items.filter(owned);
    if (gifts.length) await json('/cart/update.js',{updates:Object.fromEntries(gifts.map(x=>[x.key,0]))});
    const others=(cart.discount_codes || []).filter(x=>!codes.has(x.code.toUpperCase())).map(x=>x.code);
    if ((cart.discount_codes || []).some(x=>codes.has(x.code.toUpperCase()))) await json('/cart/update.js',{discount:others.join(',')});
  }
  function fingerprint(cart,win) {
    return JSON.stringify([win?.code,cart.items.filter(x=>!owned(x)).map(x=>[x.variant_id,x.quantity,x.final_line_price,x.properties]),(cart.discount_codes||[]).filter(x=>!codes.has(x.code.toUpperCase())).map(x=>x.code)]);
  }
  async function work() {
    failed=false;
    let cart=await json('/cart.js'); lastCart=cart;
    const win=windowNow();
    if (!eligibility(cart,win)) {
      const hadGift=cart.items.some(owned);const hadCode=(cart.discount_codes||[]).some(x=>codes.has(x.code.toUpperCase()));
      if(hadGift||hadCode){await removeOwned(cart);cart=await json('/cart.js');} lastCart=cart; status=''; if(hadGift&&window.kachingCartApi?.refreshCart)await window.kachingCartApi.refreshCart();paint(); return;
    }
    const key=fingerprint(cart,win);
    if (key===rejected) {status='Das Geschenk ist für diesen Warenkorb oder das aktuelle Kontingent nicht verfügbar.';paint();return;}
    const product=await json(config.stockUrl);
    const variant=product.variants?.find(x=>x.id===config.giftVariantId);
    if (!variant?.available) {await removeOwned(cart);lastCart=await json('/cart.js');status='Die BBQ-Zugabe ist momentan nicht verfügbar.';paint();return;}
    if (free(cart)) { status='Deine Zugabe: 1 × BIO BBQ Sauce (250 ml), kostenlos.';lastCart=cart;paint();return; }
    const gifts=cart.items.filter(owned);
    if (gifts.length !== 1 || gifts[0].quantity !== 1) {
      await removeOwned(cart);
      await json('/cart/add.js',{items:[{id:config.giftVariantId,quantity:1,properties:{_js_week_goodie:'bbq-v1'}}]});
    }
    await json('/cart/update.js',{discount:win.code});
    cart=await json('/cart.js');
    if (!free(cart) || !eligibility(cart,win)) {
      await removeOwned(cart);cart=await json('/cart.js');rejected=fingerprint(cart,win);status='Das Geschenk ist für diesen Warenkorb oder das aktuelle Kontingent nicht verfügbar.';
    } else {rejected='';status='Deine Zugabe: 1 × BIO BBQ Sauce (250 ml), kostenlos.';}
    lastCart=cart;paint();
    if (window.kachingCartApi?.refreshCart) await window.kachingCartApi.refreshCart();
    document.dispatchEvent(new CustomEvent('jaesa:week-goodie-updated',{detail:{cart}}));
  }
  function reconcile() {
    if (running) return running;
    running=work().catch(()=>{failed=true;status='Bitte lade den Warenkorb neu, damit wir die kostenlose Zugabe prüfen können.';paint();}).finally(()=>{running=null;});
    return running;
  }
  function schedule() { clearTimeout(timer);timer=setTimeout(reconcile,250); }
  function decline() {
    declined=true;try{sessionStorage.setItem('js-week-goodie-declined','1');}catch(_){}schedule();
  }
  function paintBanner() {
    const template=document.getElementById('js-week-goodie-banner');
    if(!template)return;
    const active=windowNow() && !status.startsWith('Das Geschenk') && !status.startsWith('Die BBQ');
    const existing=document.querySelector('main .js-week-goodie-banner');
    if(!active){existing?.remove();return;}
    if(existing)return;
    const main=document.getElementById('MainContent');
    if(main?.firstElementChild)main.firstElementChild.after(template.content.cloneNode(true));
  }
  function paint() {
    paintBanner();
    const productTemplate=document.getElementById('js-week-goodie-product');
    const productNotice=document.querySelector('.js-week-goodie-product');
    const productActive=windowNow() && productTemplate && food.has(Number(productTemplate.dataset.productId)) && !status.startsWith('Das Geschenk') && !status.startsWith('Die BBQ');
    if(!productActive) productNotice?.remove();
    else if(!productNotice) document.getElementById('r-pdp-buy')?.prepend(productTemplate.content.cloneNode(true));
    const panels=Array.from(document.querySelectorAll('.js-week-goodie'));
    panels.forEach((node,index)=>{if(node.dataset.copy!==status||index>0)node.remove();});
    if (!status) return;
    const appTarget=document.querySelector('.kaching-cart__checkout-button');
    const targets = appTarget?[appTarget]:Array.from(document.querySelectorAll(checkoutSelector)).slice(0,1);
    for (const target of targets) {
      if (!target.parentElement || target.closest('.js-week-goodie') || target.parentElement.querySelector(':scope > .js-week-goodie')) continue;
      const node=document.createElement('div');node.className='js-week-goodie';node.dataset.copy=status;node.setAttribute('role','status');
      const label=document.createElement('strong');label.textContent=status;node.append(label);
      if (lastCart?.items.some(owned)) {
        const link=document.createElement('a');link.href='/products/bio-bbq-sauce';link.textContent='Zutaten und Allergene';node.append(link);
        node.append(document.createElement('br'));
        const button=document.createElement('button');button.type='button';button.textContent='Ohne Sauce bestellen';button.addEventListener('click',decline);node.append(button);
      }
      target.before(node);
    }
  }
  // Observe existing cart calls without changing app responses. Our calls use baseFetch.
  window.fetch=async function(input,init) {
    const url=typeof input==='string'?input:input?.url || '';
    if (/\/cart\/(change|update)(\.js)?(?:\?|$)/.test(url) && init?.body && lastCart) {
      try {
        const body=typeof init.body==='string'?JSON.parse(init.body):null;
        if (body && Number(body.quantity)===0 && lastCart.items.some(x=>owned(x)&&(body.id===x.key||String(body.id)===String(x.variant_id)))) decline();
        if (body?.updates && lastCart.items.some(x=>owned(x)&&Number(body.updates[x.key])===0)) decline();
      } catch (_) {}
    }
    const result=await baseFetch(input,init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url)) schedule();
    return result;
  };
  // One pre-checkout chain: the existing campaign guard calls this before it
  // validates its own gift and the chosen delivery date. Avoid nested click replays.
  async function beforeCheckout() {
    if (!windowNow() && !lastCart?.items.some(owned)) return true;
    await reconcile();
    const cart=await json('/cart.js').catch(()=>null);
    return Boolean(cart && !failed && (!cart.items.some(owned) || free(cart)));
  }
  window.jaesaWeekGoodieBeforeCheckout=beforeCheckout;
  document.addEventListener('click',async event=>{
    const button=event.target.closest(checkoutSelector);
    if (window.jaesaSteakGiftGuard || !button || bypass.has(button) || button.closest('#kaching-cart[data-j-cart-view="products"]')) return;
    if (!windowNow() && !lastCart?.items.some(owned)) return;
    event.preventDefault();event.stopImmediatePropagation();
    await reconcile();
    const cart=await json('/cart.js').catch(()=>null);
    if (!cart || failed || (cart.items.some(owned) && !free(cart))) return;
    const current=button.isConnected?button:document.querySelector(checkoutSelector);
    if(!current)return;
    bypass.add(current);current.click();bypass.delete(current);
  },true);
  document.addEventListener('submit',async event=>{
    const button=event.submitter;
    if (window.jaesaSteakGiftGuard || !button?.matches(checkoutSelector) || bypass.has(button) || (!windowNow()&&!lastCart?.items.some(owned))) return;
    event.preventDefault();event.stopImmediatePropagation();await reconcile();
    const cart=await json('/cart.js').catch(()=>null);
    if(!cart||failed||(cart.items.some(owned)&&!free(cart)))return;
    bypass.add(button);event.target.requestSubmit(button);bypass.delete(button);
  },true);
  let phase=windowNow()?.code||'';
  setInterval(()=>{const next=windowNow()?.code||'';if(next!==phase||(lastCart?.items.some(owned)&&!next)){phase=next;schedule();}},30000);
  let repaintTimer;
  new MutationObserver(records=>{
    if (records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&!n.classList.contains('js-week-goodie')&&!n.closest?.('.js-week-goodie')))) {
      clearTimeout(repaintTimer);repaintTimer=setTimeout(paint,100);
    }
  }).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('cart:updated',schedule);
  document.addEventListener('kaching-cart:cart-updated',schedule);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
  schedule();
})();
